import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { SolicitudAfiliacion } from 'src/app/core/models/request/solicitud-afiliacion';
import { environment } from '../../../../environments/environment';
import { DataFileMassProcess } from '../../models/affiliation/data-file-mass-process';
import { FilterAffiliateProcess } from '../../models/affiliation/filter-affiliate-process';
import { IAffiliateBeneficiary, IAffiliateInformation, IAffiliatesProcess, IAffiliateTitular, IAffiliationData, IBasicData } from '../../models/affiliation/iaffiliate-process';
import { HttpHeadersPortal, HttpService } from './../../http/http.service';
import { GeneralResponse, MasApiResponse, PageResponse } from './../../models/general-response/general-response';
import { ModalVariadoService } from '../modal-variado/modal-variado.service';
import { mensajeModalListadoTrabajadores } from '../../enums/mensaje-modal-listado-trabajadores.enum';
import { cleanParams } from '../../utils/http-params';
import { UserService } from '../user/user.service';
import { IValidataUser } from '../../models/user/user';
import { IValidateFile } from '../../models/affiliation/ivalidate-file';

@Injectable({
  providedIn: 'root'
})
export class AffiliationService {
  idModal = 'm-load';

  private titularSubject = new BehaviorSubject<IAffiliateTitular | null>(null);
  private conyugeSubject = new BehaviorSubject<IBasicData | null>(null);
  private beneficiariosSubject = new BehaviorSubject<IAffiliateBeneficiary[]>([]);

  titularAfiliado$ = this.titularSubject.asObservable();
  conyugeAfiliado$ = this.conyugeSubject.asObservable();
  beneficiariosAfiliado$ = this.beneficiariosSubject.asObservable();

  constructor(
    private _ModalVariadoService: ModalVariadoService,
    private httpService: HttpService,
    private _userService: UserService) {
  }

  createAffiliation(dataAffiliation: SolicitudAfiliacion): Observable<GeneralResponse<any>> {
    return this.httpService.post(
      environment.GESTOR_SOLICITUDES.API_CLIENTE.PREFIJO_URL,
      '/solicitudes',
      dataAffiliation
    ).pipe(
      map((response) => {
        return response as GeneralResponse<any>;
      })
    );

  }

  uploadFile(url: string, file: File, name: string, size: string, tidEmpleador: string, idEmpleador: string, dig: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', name);
    formData.append('size', size);
    formData.append('tidEmpleador', tidEmpleador);
    formData.append('idEmpleador', idEmpleador);
    formData.append('dig', dig);


    return this.httpService.put(
      environment.AFILIACION_MASIVA.API_URL,
      '/archivos/cargar',
      formData
    ).pipe(
      map((response) => {
        return response as GeneralResponse<IValidateFile>;
      }),
      timeout(3600000)
    );

  }

  processData(dataFile: DataFileMassProcess): Observable<any> {
    return this.httpService.post(
      environment.AFILIACION_MASIVA.API_URL,
      '/archivos/processFile',
      dataFile
    ).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTopAffiliations(nit: string, quantity: string): Observable<Array<IAffiliatesProcess>> {
    const params = {
      nit,
      cantidad: quantity
    };

    return this.httpService.get<GeneralResponse<Array<IAffiliatesProcess>>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/top/afiliaciones/mes/actual',
      params
    ).pipe(map((response => response.body)));

  }

  getDetailAffiliation(affiliatesProcess: IAffiliatesProcess): Observable<IAffiliationData> {
    return this.httpService.post<GeneralResponse<IAffiliationData>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/afiliaciones/detalle',
      affiliatesProcess
    ).pipe(map((response => response.body)));
  }

  getExcelAffiliationMas(affiliatesProcess: IAffiliatesProcess): Observable<string> {
    return this.httpService.post<GeneralResponse<string>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/afiliaciones/excel',
      affiliatesProcess
    ).pipe(map((response => response.body)));
  }

  getDataAffiliationsByFilters(filterAffiliateProcess: FilterAffiliateProcess): Observable<Array<IAffiliatesProcess>> {
    return this.httpService.post<GeneralResponse<Array<IAffiliatesProcess>>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/afiliaciones',
      filterAffiliateProcess
    ).pipe(map((response => response.body)));
  }

  getSolicitudesByEmpresa1(numeroIdentidadEmpresa: string, limit: number): Observable<IAffiliatesProcess[]> {
    const params = {
      numeroIdentidadEmpresa: numeroIdentidadEmpresa,
      maxRegistros: limit.toString()
    };
    return this.httpService.get<IAffiliatesProcess[]>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/api/solicitudes/fecha',
      params
    );
  }

  getSolicitudesByEmpresa(numeroIdentidadEmpresa: string, limit: number): Observable<IAffiliatesProcess[]> {
    const params = {
      page: 0,
      size: limit.toString()
    };
    return this.httpService.get<IAffiliatesProcess[]>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      `/api/solicitudes/empresa/${numeroIdentidadEmpresa}`,
      params
    );
  }

  getRequestsByFilters(filterAffiliateProcess: FilterAffiliateProcess): Observable<IAffiliatesProcess[]> {
    const params = {
      radicado: filterAffiliateProcess.radicado || '',
      fechaSeleccionada: filterAffiliateProcess.fecha || '',
      estado: filterAffiliateProcess.estado || '',
      nit: filterAffiliateProcess.nit
    };

    return this.httpService.get<IAffiliatesProcess[]>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/api/solicitudes/filtrar',
      params
    );
  }

  filtrarHistorico(
    filterAffiliateProcess: FilterAffiliateProcess & { page: number }
  ): Observable<PageResponse<IAffiliatesProcess>> {

    const params = cleanParams({
      radicado: filterAffiliateProcess.radicado || '',
      fechaSeleccionada: filterAffiliateProcess.fecha || '',
      estado: filterAffiliateProcess.estado || '',
      nit: filterAffiliateProcess.nit,
      page: filterAffiliateProcess.page
    });

    return this.httpService.get<PageResponse<IAffiliatesProcess>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/api/solicitudes/filtrar-historico',
      params
    );
  }

  filtrarHistoricoAntiguos(
    filterAffiliateProcess: FilterAffiliateProcess & { page: number }
  ): Observable<PageResponse<IAffiliatesProcess>> {

    const params = cleanParams({
      radicado: filterAffiliateProcess.radicado || '',
      fechaSeleccionada: filterAffiliateProcess.fecha || '',
      nit: filterAffiliateProcess.nit,
      page: filterAffiliateProcess.page
    });

    return this.httpService.get<PageResponse<IAffiliatesProcess>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/api/solicitudes/filtrar-historico-antiguos',
      params
    );
  }

  filtrarHistoricoMasivo(
    filterAffiliateProcess: FilterAffiliateProcess & { pageSize: number; nextPartitionKey?: string | null; nextRowKey?: string | null; }
  ): Observable<MasApiResponse<IAffiliatesProcess>> {

    const params = cleanParams({
      radicado: filterAffiliateProcess.radicado || '',
      fecha: filterAffiliateProcess.fecha || '',
      estado: filterAffiliateProcess.estado || '',
      nit: filterAffiliateProcess.nit,
      pageSize: filterAffiliateProcess.pageSize,
      consultaMensual:filterAffiliateProcess.consultaMensual,
      nextPartitionKey: filterAffiliateProcess.nextPartitionKey ?? null,
      nextRowKey: filterAffiliateProcess.nextRowKey ?? null
    });

    return this.httpService.post<MasApiResponse<IAffiliatesProcess>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/afiliaciones/mas',
      params
    ).pipe(map((response => response)));
  }

  detallesFiltro(filterAffiliateProcess: IAffiliatesProcess): Observable<IAffiliatesProcess> {
    const params = { id: String(filterAffiliateProcess.id) };

    return this.httpService.get<IAffiliatesProcess>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      `/api/solicitudes/DetalleFiltro`,
      params
    );
  }

  async descargarListadoDeTrabajadoresVigentes(
    tipoIdentidadEmpresa: string,
    numeroIdentidadEmpresa: string,
    adjuntoBeneficiario: boolean = false,
    emailDestinatario: string
  ) {
    const baseUrl = environment.GESTOR_SOLICITUDES.API_CONSULTAS_V2.PREFIJO_URL;
    const urlReporte = environment.GESTOR_SOLICITUDES.API_CONSULTAS_V2.AFILIADOS_ENDPOINT;
    const fullUrl = `${baseUrl}${urlReporte}`;
    const queryString = `/async?tipoIdentidad=${encodeURIComponent(tipoIdentidadEmpresa)}&numeroIdentidad=${encodeURIComponent(numeroIdentidadEmpresa)}&adjuntoBeneficiario=${adjuntoBeneficiario}&emailDestinatario=${encodeURIComponent(emailDestinatario)}`;
    const headers: HttpHeadersPortal = this.httpService.getGlobalHeaders();
    const modalRef = this._ModalVariadoService.ModalProceso('Generando el listado de trabajadores...');
    try {
      await this.httpService.post<void>(fullUrl, queryString, null, null, headers).toPromise();
      this._ModalVariadoService.modalConfirmacion(mensajeModalListadoTrabajadores.confirmacionYEnvio);
    } catch (error) {
      this._ModalVariadoService.modalError(mensajeModalListadoTrabajadores.error + error);
      console.error('Error al iniciar el proceso:', error);
    } finally {
      modalRef.close();
    }
  }


  obtenerDocumentoVigente(
    tipoIdentidadEmpresa: string,
    numeroIdentidadEmpresa: string,
    emailDestinatario: string
  ): Observable<any> {
    const baseUrl = environment.GESTOR_SOLICITUDES.API_CONSULTAS_V2.PREFIJO_URL;
    const urlReporte = '/api/procesos-cola';
    const fullUrl = `${baseUrl}${urlReporte}`
    const queryString = `/empresa?tipoIdentidad=${encodeURIComponent(tipoIdentidadEmpresa)}&numeroIdentidad=${encodeURIComponent(numeroIdentidadEmpresa)}&emailDestinatario=${encodeURIComponent(emailDestinatario)}`;
    const headers: HttpHeadersPortal = this.httpService.getGlobalHeaders();
    return this.httpService.get(fullUrl, queryString, null, headers)
  }

  getInfoAffiliateBasic(typeDocument: string, numberDocument: string): Observable<IAffiliateInformation> {
  const user: IValidataUser = {
    idTypePerson: typeDocument,
    idPerson: numberDocument,
    idTypeEmployer: typeDocument,
    idEmployer: numberDocument,
  };

  return this._userService.validateUser(user, true).pipe(
      map(response => {
        if (response.body) {
          return {
            informacionAfiliado: this.mapAfiliado(response.body.afiliado),
            informacionBeneficiario: this.mapBeneficiarios(response.body.pacs)
          } as IAffiliateInformation;
        }
        return null; 
      })
    );
  }

  public mapAfiliado(afiliado: any): IAffiliateTitular {
    return {
      numeroDocumento: afiliado.numeroDocumento,
      tipoDocumento: afiliado.tipoDocumento,
      primerNombre: afiliado.primerNombre,
      segundoNombre: afiliado.segundoNombre,
      primerApellido: afiliado.primerApellido,
      segundoApellido: afiliado.segundoApellido,
      fechaNacimiento: afiliado.fechaNacimiento,
      genero: afiliado.genero,
      estadoCivil: afiliado.estadoCivil
    };
  }
  
  public mapBeneficiarios(pacs: any[]): IAffiliateBeneficiary[] {
    if (!pacs) return [];
    return pacs.map(pac => ({
      tipoDocumento: pac.tipoDocumento,
      numeroDocumento: pac.numeroDocumento,
      primerNombre: pac.primerNombre,
      segundoNombre: pac.segundoNombre,
      primerApellido: pac.apellido,          
      segundoApellido: pac.segundoApellido,
      fechaNacimiento: pac.fechaNacimiento,
      genero: pac.genero,
      parentesco: pac.relacion?.descripcion  
    }));
  }

  actualizarTitular(titular: IAffiliateTitular) {
    this.titularSubject.next(titular);
  }

  actualizarConyuge(conyuge: IBasicData) {
    this.conyugeSubject.next(conyuge);
  }

  actualizarBeneficiarios(beneficiarios: IAffiliateBeneficiary[]) {
    this.beneficiariosSubject.next(beneficiarios);
  }

  resetTitular() {
    this.titularSubject.next(null);
  }

  resetConyuge() {
    this.conyugeSubject.next(null);
  }

  resetBeneficiarios() {
    this.beneficiariosSubject.next([]);
  }

}

